import { getNextRecurringDate } from 'components/organisms/RecurringField/helpers';
import dayjs from 'dayjs';
import { ExpenseRecurrenceFrequency } from 'types/expenses.types';
import { Step } from './types';

export const frequencyOptions: Step[] = [
  {
    value: ExpenseRecurrenceFrequency.weekly,
    unit: 'week',
    every: 1,
  },
  {
    value: ExpenseRecurrenceFrequency.monthly,
    unit: 'month',
    every: 1,
  },
  {
    value: ExpenseRecurrenceFrequency.quarterly,
    unit: 'month',
    every: 3,
  },
];

export const getStartDateBasedOnExpenseDate = (
  frequency: string | undefined,
  expense_date: string | undefined,
) => {
  if (!frequency || !expense_date) return null;

  const date = dayjs(expense_date);
  if (!date.isValid()) return null;

  const stepData = frequencyOptions.find(
    (option) => option.value === frequency,
  );
  if (!stepData) return null;
  const { every, unit } = stepData;

  const dateString = date.format('YYYY-MM-DD');

  return getNextRecurringDate(
    dateString,
    {
      every,
      unit,
      dayNumber: date.date(),
      dayToken: 'other',
    },
    {
      incrementFutureEvents: true,
      incrementTodayEvents: dateString === dayjs().format('YYYY-MM-DD'),
    },
  );
};

export const getFirstRecurrenceDate = (
  frequency: string | undefined,
  start_date: string | undefined,
  expense_date: string | undefined,
) => {
  if (!frequency || !start_date || !expense_date) return null;

  if (!dayjs(start_date).isValid() || !dayjs(expense_date).isValid()) {
    return null;
  }

  const expenseDate = dayjs(expense_date).format('YYYY-MM-DD');
  const startDate = dayjs(start_date).format('YYYY-MM-DD');
  const today = dayjs().format('YYYY-MM-DD');

  const isSameDay = expenseDate === startDate;

  if (!isSameDay) return startDate;

  return getStartDateBasedOnExpenseDate(frequency, expense_date);
};
